var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 28.3334C22.8114 28.3334 28.3333 22.8116 28.3333 16C28.3333 9.18853 22.8114 3.66671 15.9999 3.6667C9.18841 3.6667 3.66659 9.18853 3.66659 16C3.66658 22.8116 9.18841 28.3334 15.9999 28.3334ZM30.3333 16C30.3333 23.9161 23.916 30.3334 15.9999 30.3334C8.08384 30.3334 1.66658 23.9161 1.66659 16C1.66659 8.08396 8.08384 1.6667 15.9999 1.6667C23.916 1.66671 30.3333 8.08396 30.3333 16ZM15.9999 21.6667C15.4476 21.6667 14.9999 21.219 14.9999 20.6667L14.9999 13.7476L12.707 16.0405C12.3165 16.431 11.6833 16.431 11.2928 16.0405C10.9023 15.65 10.9023 15.0168 11.2928 14.6263L15.2928 10.6263C15.6833 10.2357 16.3165 10.2357 16.707 10.6263L20.707 14.6263C21.0976 15.0168 21.0976 15.65 20.707 16.0405C20.3165 16.431 19.6833 16.431 19.2928 16.0405L16.9999 13.7476L16.9999 20.6667C16.9999 21.219 16.5522 21.6667 15.9999 21.6667Z",
    fill: "#003F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.0321188e35c01bb5ce35091e90320756.svg";
export { ForwardRef as ReactComponent };